export enum OpportunityMutationTypes {
  SET_OPPORTUNITY = "SET_OPPORTUNITY",
  SET_OPPORTUNITY_FIELD = "SET_OPPORTUNITY_FIELD",
  SET_COMPLETE_OPPORTUNITY = "SET_COMPLETE_OPPORTUNITY",
  SET_OPPORTUNITY_UNIQUE = "SET_COMPLETE_OPPORTUNITY_UNIQUE",
  SET_SELECTED_MARKET_BUTTON = "SET_SELECTED_MARKET_BUTTON",
  SET_SELECTED_BI_OPPORTUNITY_URL = "SET_SELECTED_BI_OPPORTUNITY_URL",
}

